<app-modal-dialog [configuration]="modalDialogConfiguration">
  <div class="pdf-stream">
    <pdf-viewer [src]="pdfUrl" [render-text]="true" [external-link-target]="'blank'" [fit-to-page]="true" style="height: 100%;">
    </pdf-viewer>
  </div>
</app-modal-dialog>
